module.exports = __webpack_public_path__ + "img/__message_sm.9150d92b.svg";